var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #7dc680;\n        stroke-width: 2.5px;\n      }\n\n      .st1, .st2 {\n        fill: #7dc680;\n      }\n\n      .st2 {\n        opacity: .2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 40.231,
    y: 28.244,
    width: 49.537,
    height: 13.619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "58.646 14.441 71.354 14.441 74.189 28.244 55.811 28.244 58.646 14.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65 62.725 28.254 65.746 39.589 112.75 90.411 112.75 101.746 65.746 65 62.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "35.076 65.185 35.076 41.863 94.924 41.863 94.924 65.185"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 65.008,
    y1: 49.145,
    x2: 65.01,
    y2: 71.54
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 74.189,
    y1: 27.52,
    x2: 87.791,
    y2: 41.122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 65,
    y1: 28.463,
    x2: 78.337,
    y2: 41.801
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.444,81.788c-2.779,0-4.168.918-4.168,2.754,0,.816.344,1.44,1.032,1.874s2.301,1.058,4.838,1.874c2.536.816,4.315,1.74,5.335,2.772s1.529,2.62,1.529,4.762c0,2.729-.828,4.793-2.484,6.195-1.658,1.402-3.825,2.104-6.503,2.104-1.988,0-4.424-.306-7.305-.918l-1.376-.268.535-4.092c3.416.458,6.029.688,7.84.688,2.702,0,4.054-1.121,4.054-3.365,0-.815-.312-1.453-.937-1.912-.625-.459-1.868-.956-3.729-1.491-2.958-.842-5.043-1.842-6.254-3.003-1.211-1.159-1.816-2.772-1.816-4.838,0-2.601.79-4.538,2.371-5.812,1.581-1.275,3.748-1.912,6.502-1.912,1.887,0,4.283.255,7.189.765l1.377.268-.42,4.169c-3.596-.408-6.133-.612-7.611-.612Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialist);
export default __webpack_public_path__ + "static/media/specialist.d97f03980c52aa17ac5fbda4f55f4eba.svg";
export { ForwardRef as ReactComponent };